var map = {
	"./tela-preta-cinza (30).webp": 6503,
	"./tela-preta-cinza (34).webp": 176,
	"./tela-preta-cinza (38).webp": 8191,
	"./tela-preta-cinza (39).webp": 3535,
	"./tela-preta-cinza-11.webp": 7852,
	"./tela-preta-cinza-6.webp": 4241,
	"./tela-preta-cinza-8.webp": 2204,
	"./tela-preta-cinza-site (57).webp": 7743,
	"./tela-preta-cinza-site (69).webp": 3497,
	"./tela-preta-cinza-site (73).webp": 5744,
	"./tela-preta-cinza-site (79).webp": 1603,
	"./tela-preta-cinza-site (87).webp": 1626
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6110;